import { cloneElement } from 'react';

export const renderChildren = (children, props = {}) => {
    if (!children) return null;
    if (typeof children === 'function') return children(props);
    if (typeof children === 'string') return <>{children}</>;
    if (children instanceof Array) {
        return children.map(child => cloneElement(child, props));
    }
    return cloneElement(children, props);
};
